import {Dialog, Transition} from "@headlessui/react";
import {DangerButton} from "../../Buttons/DangerButton";
import {BlackButton} from "../../Buttons/BlackButton";
import {Fragment, useEffect, useState} from "react";
import {useTranslation} from "react-i18next";

export const DeleteConfirmDialog = (props) => {
    const {
        open,
        onClose,
        onConfirm
    } = props;

    const {t} = useTranslation();
    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        if (!open) setIsDeleting(false);
    }, [open]);

    const handleConfirm = async () => {
        if (isDeleting) return;
        setIsDeleting(true);
        try {
            await onConfirm();
        } catch (e) {
            setIsDeleting(false);
        }
    };

    return (
        <>
            <Transition appear show={open} as={Fragment}>
                <Dialog as="div" className="relative z-999" onClose={onClose}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-black/50"/>
                    </Transition.Child>

                    <div className="fixed inset-0 overflow-y-auto z-999">
                        <div className="flex min-h-full items-center justify-center p-4 text-center z-999">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95"
                            >
                                <Dialog.Panel
                                    className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                                    <Dialog.Title
                                        as="h3"
                                        className="text-lg font-medium leading-6 text-gray-900"
                                    >
                                        {t('dialogs.confirm.delete_title')}
                                    </Dialog.Title>
                                    <div className="mt-2">
                                        <p className="text-sm text-gray-500">
                                            {t('dialogs.confirm.delete_message')}<br/>
                                            {t('dialogs.confirm.cannot_undo')}
                                        </p>
                                    </div>

                                    <div className={'flex justify-end'}>
                                        <div className="mt-4 grid grid-cols-2 w-fit gap-4">
                                            <div>
                                                <BlackButton outlined={true} onClick={onClose} disabled={isDeleting}>{t('general.actions.cancel')}</BlackButton>
                                            </div>
                                            <DangerButton onClick={handleConfirm} disabled={isDeleting}>{t('general.actions.delete')}</DangerButton>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}